var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.43738 1.75098C12.8491 1.75098 15.6249 4.54773 15.6249 7.98573C15.6249 12.212 10.7829 16.376 9.43738 16.376C8.09188 16.376 3.24988 12.212 3.24988 7.98573C3.24988 4.54773 6.02563 1.75098 9.43738 1.75098ZM9.43738 2.87598C6.64588 2.87598 4.37488 5.16873 4.37488 7.98573C4.37488 11.57 8.59288 15.062 9.43738 15.248C10.2819 15.0612 14.4999 11.5692 14.4999 7.98573C14.4999 5.16873 12.2289 2.87598 9.43738 2.87598ZM9.43813 5.50098C10.7821 5.50098 11.8756 6.59448 11.8756 7.93923C11.8756 9.28323 10.7821 10.376 9.43813 10.376C8.09413 10.376 7.00063 9.28323 7.00063 7.93923C7.00063 6.59448 8.09413 5.50098 9.43813 5.50098ZM9.43813 6.62598C8.71438 6.62598 8.12563 7.21473 8.12563 7.93923C8.12563 8.66298 8.71438 9.25098 9.43813 9.25098C10.1619 9.25098 10.7506 8.66298 10.7506 7.93923C10.7506 7.21473 10.1619 6.62598 9.43813 6.62598Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.def3634bacf15ea1c23a8f6551addc19.svg";
export { ForwardRef as ReactComponent };